/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import moment from "moment-timezone";
moment.locale('ja')
import { defineModule } from 'direct-vuex'
import { moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
import * as types from '@/lib/definition/types'

export interface CalendarState {
  timesheets: any[];
  workTypes: any[];
  personalWorkTypes: any[];
  [key: string]: any;
}

const calendar = defineModule({
  state: (): CalendarState => {
    return {
      timesheets: [],
      workTypes: [],
      personalWorkTypes: []
    }
  },
  getters: {
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    }
  },
  actions: {
    async getGroupsOnly (context): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/getgroups', "カレンダーグループの取得に失敗しました。", {}, rootState.Login.accessToken)
      var groups = retval.data.data
      return groups
    },
    async getWorkTypes(context): Promise<any> {
      const { rootState, commit } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/worktypes', "Failed to receive Worktype", {}, rootState.Login.accessToken)
      var workTypes = retval.data.data
      commit.SET_VALUE({name: 'workTypes', value: workTypes})
      return workTypes
    },
    async getPersonalWorkTypes(context): Promise<any> {
      const { rootState, commit } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/personalworktypes', "Failed to receive Worktype", {}, rootState.Login.accessToken)
      var workTypes = retval.data.data
      commit.SET_VALUE({name: 'personalWorkTypes', value: workTypes})
      return workTypes
    },
    async getGroups(context, yearMonth: number): Promise<any> {
      const { rootState, state, dispatch } = moduleActionContext(context, calendar)
      if (state.workTypes.length == 0) {
        await dispatch.getWorkTypes()
      }
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/getgroups', "Failed to receive Groups", {}, rootState.Login.accessToken)
      var groups = retval.data.data
      const retval2 = await Lib.Ajax.getHandleError<any>('/api/calendar/calendarsformonth', "Failed to receive Groups", { yearMonth: yearMonth == null ? '' : yearMonth.toString() }, rootState.Login.accessToken)
      var calendars = retval2.data.data
  
      const retval3 = await Lib.Ajax.getHandleError<any>('/api/calendar/getgroupworktypes', "Failed to receive Groups", {}, rootState.Login.accessToken)
      var groupWorks = retval3.data.data
  
      
      groups.forEach((element: any) => {
        element.calendars = []
        groupWorks.forEach((gw: any) => {
          if (element.calendarGroupId == gw.calendarGroupId) {
            if (element.groupWorks == null) {
              element.groupWorks = []
            }
            state.workTypes.forEach(wt => {
              if (wt.tenantWorkTypeId == gw.tenantWorkTypeId) {
                gw.name = wt.name
              }
            })
            element.groupWorks.push(gw)
          }
        })
        calendars.forEach((cal: any) => {
          if (element.calendarGroupId == cal.calendarGroupId) {
            cal.dateM = moment(cal.date)
            cal.dateDisp = cal.dateM.format('YYYY-MM-DD (ddd)')
            element.calendars.push(cal);
          }
        })
      });
      return groups
    },
    async createGroup(context, {identifier, name}): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/creategroup', "Failed to receive Groups", {identifier: identifier, name: name}, rootState.Login.accessToken)
      var group = retval.data.data
      return group
    },
    async updateDay(context, payload: {calendarDayId: string; param: string, value: string}): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/updateday/' +payload.calendarDayId, "Failed to receive Days", {param: payload.param, value: payload.value}, rootState.Login.accessToken)
      var group = retval.data.data
      return group
    },
    async updateGroup(context, {calendarGroupId, param, value}): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/updategroup/' + calendarGroupId, "Failed to receive Groups", {param, value}, rootState.Login.accessToken)
      var group = retval.data.data
      return group
    },
    async updateGroupWorkType(context, {calendarGroupWorkTypeId, param, value}): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/updategroupworktype/' + calendarGroupWorkTypeId, "Failed to receive Groups", {param, value}, rootState.Login.accessToken)
      var group = retval.data.data
      return group
    },
    async updatePersonal(context, {personalCalendarId, param, value, plan, comment, tenantWorkTypeIdAM, tenantWorkTypeIdPM}): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      var p: any = {param, value}
      if (comment != null) {
        p.comment = comment
      }
      if (param == 'change') {
        p.value = tenantWorkTypeIdAM + '|' + tenantWorkTypeIdPM
        p.comment = JSON.stringify({comment, plan})
      }
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/updatepersonal/' + personalCalendarId, "Failed to receive Groups", p, rootState.Login.accessToken)
      var group = retval.data.data
      return group
    },
    async createpersonal(context, yearMonth): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/createpersonal', "Failed to Create Calendar", {yearMonth}, rootState.Login.accessToken)
      var group = retval.data.data
      return group
    },
    async getMyWeekly(context, targetMonday): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/myweekly/' + targetMonday, "Failed to Create Calendar", {}, rootState.Login.accessToken)
      var group = retval.data.data
      if (rootState.Home.isPrivacyMode) {
        group.weeklyMessage = rootState.PrivacyWord.privacyWords.reduce((prev: string|null, current: types.PrivacyWord) => {
          return prev == null ? null : prev.replace(new RegExp(current.targetWord, 'ig'), current.alternateWord)
        }, group.weeklyMessage)
      }
      return group
    },
    async updateMyWeekly(context, {targetMonday, weeklyMessage}): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.postHandleError<any>('/api/calendar/updateweekly/' + targetMonday, "週報の登録に失敗しました。", {weeklyMessage}, rootState.Login.accessToken)
      var group = retval.data.data
      return group
    },
    async membersActivity(context, {startDay, endDay}): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/membersactivity', "Failed to Create Calendar", {startDay, endDay}, rootState.Login.accessToken)
      var group = retval.data.data
      var byUser: any[] = []
      group.forEach((element: any) => {
        element.dateM = moment(element.date)
        element.dateDisp = element.dateM.format('M/D(dd)')
        if (!byUser.reduce((prev, current) => {
          if (current.displayName == element.displayName) {
            current.dates.push(element)
            return true
          }
          return prev
        }, false)) {
          byUser.push({displayName: element.displayName, dates: [element]})
        }
      })
      return byUser
    },
    async personalCalendarDetail(context, personalCalendarId): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/personalcalendardetail/' + personalCalendarId, "Failed to Create Calendar", {}, rootState.Login.accessToken)
      var group = retval.data.data
      var workTypes = rootState.Calendar.workTypes
      group.detail.approvals.forEach((ap: any) => {
        ap.postedGMTM = moment.tz(ap.postedGMT, 'Etc/GMT')
        ap.posted = ap.postedGMTM.tz(moment.tz.guess()).format('M/D ddd HH:mm')
        ap.status = ''
        if (ap.workTypeApprovedStatus==1){
          ap.status = '申請'
        }
        if (ap.workTypeApprovedStatus==2){
          ap.status = '許可済'
        }
        if (ap.workTypeApprovedStatus==3){
          ap.status = 'マネージャによって修正済'
        }
        if (ap.workTypeApprovedStatus==4){
          ap.status = '調整中'
        }
        if (ap.workTypeApprovedStatus==5){
          ap.status = '変更'
        }
        ap.isSameWorkType = ap.tenantWorkTypeIdAM == ap.tenantWorkTypeIdPM
        ap.AMName = workTypes.reduce((prev, current) => {
          if (current.tenantWorkTypeId == ap.tenantWorkTypeIdAM) { prev = prev + current.name }
          return prev
        }, '')
        ap.PMName = workTypes.reduce((prev, current) => {
          if (current.tenantWorkTypeId == ap.tenantWorkTypeIdPM) { prev = prev + current.name }
          return prev
        }, '')
        if (ap.isSameWorkType) {
          ap.workTypeName = '終日' + ap.AMName
        } else {
          ap.workTypeName = 'AM:' + ap.AMName + " PM:" + ap.PMName
        }
      })
      return group
    },
    async listToApprove(context): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/listtoapprove', "Failed to Create Calendar", {}, rootState.Login.accessToken)
      var workTypes = rootState.Calendar.workTypes
      var list = retval.data.data
      list.forEach((element: any) => {
        element.workTypeApprovedStatus = element.approvals.reduce((prev: number, current: any) => {
          current.postedGMTM = moment.tz(current.postedGMT, 'Etc/GMT')
          current.posted = current.postedGMTM.tz(moment.tz.guess()).format('M月D日(ddd) HH:mm')
          current.status = ''
          if (current.workTypeApprovedStatus==1){
            current.status = '申請'
          }
          if (current.workTypeApprovedStatus==2){
            current.status = '許可済'
          }
          if (current.workTypeApprovedStatus==3){
            current.status = 'マネージャによって修正済'
          }
          if (current.workTypeApprovedStatus==4){
            current.status = '調整中'
          }
          if (current.workTypeApprovedStatus==5){
            current.status = '調整中'
          }
          current.isSameWorkType = current.tenantWorkTypeIdAM == current.tenantWorkTypeIdPM
          current.AMName = workTypes.reduce((prev2, current2) => {
            if (current2.tenantWorkTypeId == current.tenantWorkTypeIdAM) { prev2 = current2.name }
            return prev2
          }, '')
          current.PMName = workTypes.reduce((prev2, current2) => {
            if (current2.tenantWorkTypeId == current.tenantWorkTypeIdPM) { prev2 = current2.name }
            return prev2
          }, '')
          if (current.isSameWorkType) {
            current.workTypeName = '終日' + current.AMName
          } else {
            current.workTypeName = 'AM:' + current.AMName + " PM:" + current.PMName
          }
          return current.workTypeApprovedStatus
        }, 0)
        element.postedGMTM = element.postedGMT == null ? null : moment.tz(element.postedGMT, 'Etc/GMT')
        element.posted = element.postedGMT == null ? null : element.postedGMTM.tz(moment.tz.guess()).format('M月D日(ddd) HH:mm')
        element.dateDisp = moment(element.date).format('M月D日(ddd)')
        element.status = ''
        if (element.workTypeApprovedStatus==1){
          element.status = '申請'
        }
        if (element.workTypeApprovedStatus==2){
          element.status = '許可済'
        }
        if (element.workTypeApprovedStatus==3){
          element.status = 'マネージャによって修正済'
        }
        if (element.workTypeApprovedStatus==4){
          element.status = '調整中'
        }
        if (element.workTypeApprovedStatus==5){
          element.status = '変更'
        }
        element.isSameWorkType = element.tenantWorkTypeIdAM == element.tenantWorkTypeIdPM
        element.AMName = workTypes.reduce((prev, current) => {
          if (current.tenantWorkTypeId == element.tenantWorkTypeIdAM) { prev = prev + current.name }
          return prev
        }, '')
        element.PMName = workTypes.reduce((prev, current) => {
          if (current.tenantWorkTypeId == element.tenantWorkTypeIdPM) { prev = prev + current.name }
          return prev
        }, '')
        if (element.isSameWorkType) {
          element.workTypeName = '終日' + element.AMName
        } else {
          element.workTypeName = 'AM:' + element.AMName + " PM:" + element.PMName
        }
  
      })
      return list
    },
    async getUserDefaultSchedules(context, userDetailId: string): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      const retval = await Lib.Ajax.getHandleError<any>('/api/calendar/userdefaultschedule/' + userDetailId, "Failed to receive user schedules", {}, rootState.Login.accessToken)
      return retval.data.data
    },
    async setUserDefaultSchedule(context, { userDetailId, dayOfWeek, tenantWorkTypeIdAM, tenantWorkTypeIdPM }): Promise<any> {
      const { rootState } = moduleActionContext(context, calendar)
      var params: any = {}
      if (tenantWorkTypeIdAM) params.TenantWorkTypeIdAM = tenantWorkTypeIdAM
      if (tenantWorkTypeIdPM) params.TenantWorkTypeIdPM = tenantWorkTypeIdPM
      await Lib.Ajax.getHandleError<any>('/api/calendar/userdefaultschedule/' + userDetailId + '/' + dayOfWeek, "Failed to save user schedule", params, rootState.Login.accessToken)
    }
  },
  namespaced: true
})

export default calendar
